module.exports = __webpack_public_path__ + "static/media/foto-destaque-banco-de-pedidos.e0633553.jpg";